class SiteSearch extends HTMLElement {
    static suggestionsCache = new Map(); // location -> Promise<data>
    async connectedCallback() {
        // prevent double initialization:
        if (this.initialized) return;
        this.initialized = true;
        // Render same template everywhere
        this.innerHTML = this.renderTemplate();

        this.locationVars = {
            1: {
                pageHeader: "Search Laboratory Services Handbook",
                backgroundColor: "#f7f9ff",
                websiteLink: "https://pathology.medicine.uiowa.edu",
                websiteTitle: "Department of Pathology Website",
                handbookDirectory: "handbook",
            },
            2: {
                pageHeader: "Search the Off-Campus Handbook",
                backgroundColor: "#eeffee",
                websiteLink: "https://pathology.medicine.uiowa.edu",
                websiteTitle: "Department of Pathology Website",
                handbookDirectory: "ochandbook",
            },
            4: {
                pageHeader: "Search the UIDL Test Directory",
                backgroundColor: "#fff",
                websiteLink: "https://uidl.medicine.uiowa.edu",
                websiteTitle: "University of Iowa Diagnostic Laboratories Website",
                handbookDirectory: "rhandbook",
            },
        };
        // Cache elements scoped inside this component
        this.elements = {
            container: this.querySelector('[data-role="search-container"]'),
            form: this.querySelector('[data-role="search-form"]'),
            term: this.querySelector('[data-role="search-term"]'),
            location: this.querySelector('[data-role="search-location"]'),
            submit: this.querySelector('[data-role="search-submit"]'),
            icon: this.querySelector('[data-role="search-icon"]'),
            loading: this.querySelector('[data-role="loading-icon"]'),
        };

        // Init
        this.setValueFromUrl();
        this.setLocationFromUrl();
        this.handleSearch();
        this.loc = this.elements.location.value;

        if (!SiteSearch.suggestionsCache.has(this.loc)) {
            SiteSearch.suggestionsCache.set(this.loc, this.fetchSuggestions(this.loc));
        }
        const searchSuggestions = await SiteSearch.suggestionsCache.get(this.loc);
        this.initAutocomplete(searchSuggestions);
    }
    async fetchSuggestions(location) {
        const apiUrl = `https://www.path.uiowa.edu/path_handbook/api/autoCompleteSuggestions?loc=${encodeURIComponent(location)}`;
        //const apiUrl = `/path_handbook/api/autoCompleteSuggestions?loc=${encodeURIComponent(location)}`;

        try {
            const response = await fetch(apiUrl);

            if (!response.ok) {
                throw new Error("Network response was not ok");
            }

            const data = await response.json();
            return data;
        } catch (error) {
            console.error("There was a problem with the search suggestions fetch operation:", error);
            throw error; // optional but often important
        }
    }
    renderTemplate() {
        return /*html*/ `
      <div class="search-container search-container-full-width" data-role="search-container">
        <i class="fas fa-search" data-role="search-icon"></i>
        <img src="/path_handbook/assets/images/spinner.gif" 
             data-role="loading-icon" 
             width="12" height="12" 
             alt="Loading…" 
             style="display: none">
        <form method="get" action="/path_handbook/search/" class="search" data-role="search-form">
          <span role="status" aria-live="polite" class="ui-helper-hidden-accessible"></span>
          <input name="search_term" 
                 size="21" maxlength="255"
                 data-role="search-term"
                 type="search" 
                 placeholder="Enter text to search" 
                 class="ui-autocomplete-input" 
                 autocomplete="off" 
                 required 
                 aria-label="Search the handbook">
          <input type="hidden" name="or" value="1">
          <input type="hidden" name="dirs" value="Both"> 
          <input type="hidden" name="loc" value="1" data-role="search-location">
          <button type="submit" class="bttn bttn--tertiary" data-role="search-submit">Search <span class="fas fa-arrow-right"></span></button>
        </form>
      </div>
    `;
    }

    setValueFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has("search_term")) {
            this.elements.term.value = urlParams.get("search_term");
        }
    }

    setLocationFromUrl() {
        const currentUrl = window.location.href;
        this.elements.location.value = 1;
        const rules = [
            { location: 4, matches: ["rhandbook", "rindex", "rindices", "loc=4", "Outreach"] },
            { location: 2, matches: ["ochandbook", "ocindex", "ocindices", "loc=2"] },
        ];

        const match = rules.find((rule) => rule.matches.some((m) => currentUrl.includes(m)));
        if (match) {
            this.elements.location.value = match.location;
        }
    }

    generateTestLink(Procode, loc) {
        return `/path_handbook/${loc.handbookDirectory}/test${encodeURIComponent(Procode)}.html`;
    }

    handleSearch() {
        const urlParams = new URLSearchParams(window.location.search);
        const searchTerm = urlParams.get("search_term");

        if (searchTerm) {
            const resultsElement = document.querySelector(".results");
            if (resultsElement && window.Mark) {
                new Mark(resultsElement).mark(searchTerm);
            }
        }

        window.addEventListener("pageshow", (event) => {
            if (event.persisted) this.enableSearch();
        });

        this.elements.term.addEventListener("click", () => {
            this.elements.term.select();
        });
        this.elements.form.addEventListener("submit", () => {
            this.disableSearch();
            setTimeout(() => this.enableSearch(), 3000);
        });
    }

    disableSearch() {
        this.elements.submit.disabled = true;
        this.classList.add("is-loading");
        this.elements.icon.style.display = "none";
        this.elements.loading.style.display = "block";
    }

    enableSearch() {
        this.elements.submit.disabled = false;
        this.classList.remove("is-loading");
        this.elements.icon.style.display = "block";
        this.elements.loading.style.display = "none";
    }

    initAutocomplete(data) {
        const autoCompleteJS = new autoComplete({
            selector: () => this.elements.term,
            placeHolder: "Enter text to search",

            data: {
                src: data,
                keys: ["name", "epic_code"], // search/display by name
                cache: true,
            },

            resultItem: {
                highlight: true,
            },

            resultsList: {
                maxResults: 10,
            },

            submit: true,

            events: {
                input: {
                    selection: (event) => {
                        const selection = event.detail.selection.value;

                        autoCompleteJS.input.value = selection.name;
                        this.elements.term.value = selection.name;

                        window.location = this.generateTestLink(
                            selection.id,
                            this.locationVars[this.loc],
                            selection.epic_code,
                        );
                    },
                },
            },
        });
    }
}

customElements.define("site-search", SiteSearch);
